// export default 'http://localhost:3332' // local 

// export default process.env.REACT_APP_IP || 'https://api-gofit.solvel.tech'
export default process.env.REACT_APP_IP || 'https://apolo-api.anysolve.com.br'
// export default 'https://api-fitfollow.solvel.tech'